


















































































































































































import {Component, Prop, Vue} from 'vue-property-decorator'
import {GithubOrganizationCollection} from '@/model/collection/GithubOrganizationCollection'
import {GithubOrganization} from '@/model/resource/GithubOrganization'
import {GithubRepository} from '@/model/resource/GithubRepository'

@Component({})
export default class CDOrganizationsNav extends Vue {
  @Prop({type: GithubOrganizationCollection, required: true})
  organizationCollection!: GithubOrganizationCollection

  @Prop({type: Object, default: () => ({})})
  commitsByOrganization!: Record<number, number>

  @Prop({type: Number, default: null})
  selectedOrganizationId!: number | null

  @Prop({type: Number, default: null})
  selectedRepositoryId!: number | null

  @Prop({type: Array, default: () => []})
  repositories!: GithubRepository[]

  get orderedOrganizations() {
    return [...(this.organizationCollection.items || [])].sort((a, b) => {
      const ca = this.commitsByOrganization[a.$id] ?? 0
      const cb = this.commitsByOrganization[b.$id] ?? 0
      if (cb !== ca) return cb - ca
      return (a.name || a.$tag || '').localeCompare(b.name || b.$tag || '')
    })
  }

  get selectedOrgName() {
    return (
      this.organizationCollection.items.find(
        it => it.$id === this.selectedOrganizationId
      )?.name ?? ''
    )
  }

  getBgColor(item: GithubOrganization) {
    return `background-color: #${item.colorHex}`
  }

  getBgColorById(id: number | null) {
    const org = this.organizationCollection.items.find(it => it.$id === id)
    return org?.colorHex ? `background-color: #${org.colorHex}` : ''
  }

  getRepoBgColor(repo: GithubRepository) {
    return repo.colorHex ? `background-color: #${repo.colorHex}` : ''
  }

  selectOrganization(id: number | null) {
    this.$emit('selectOrganization', id)
  }

  selectRepository(id: number) {
    this.$emit('selectRepository', id)
  }

  clearRepositorySelection() {
    if (this.selectedRepositoryId === null) return
    this.$emit('selectRepository', null)
  }
}
